module.exports = __webpack_public_path__ + "static/RUSH2-8759c51e801696c7a15cb116913b783b.png";